const baseUrl = "http://edumongolia.mn:8080/v1";
// const baseUrl = "http://127.0.0.1:8000/v1";
const mainUrl = baseUrl + "/main";
const foodUrl = baseUrl + "/food";
const kindergartenUrl = baseUrl + "/kindergarten";
const libraryUrl = baseUrl + "/library";

const ApiList = {
  // : "http://127.0.0.1:8000",
  baseMediaUrl: "http://edumongolia.mn:8080",
  allUserCountUrl: mainUrl + "/all_user_count/",
  loginUrl: mainUrl + "/auth/signin",
  forgotTokenUrl: mainUrl + "/forgot_token/",
  forgotTokenCheckUrl: mainUrl + "/forgot_token_check/",
  forgotPasswordChangeUrl: mainUrl + "/forgot_password_change/",

  userUrl: mainUrl + "/user/",
  buildingUrl: mainUrl + "/building/",
  roomUrl: mainUrl + "/classroom/",
  courseUrl: mainUrl + "/course/",
  lessonUrl: mainUrl + "/lesson/",
  shiftUrl: mainUrl + "/shift/",
  scheduleUrl: mainUrl + "/schedule/",
  scheduleDetailUrl: mainUrl + "/schedule_detail/",
  lessonTeacherTypeUrl: mainUrl + "/lesson_teacher_type/",
  positionUrl: mainUrl + "/position/",
  userCourseUrl: mainUrl + "/user_course/",
  scheduleLessonUrl: mainUrl + "/schedule_lesson/",
  myLessonUrl: mainUrl + "/my_lesson/",
  myCourseUrl: mainUrl + "/my_course/",
  uploadProfileUrl: mainUrl + "/upload/",
  scheduleClassroomUrl: mainUrl + "/schedule_classroom/",
  courseStudentsUrl: mainUrl + "/course_students/",
  teacherData: mainUrl + "/teacher_data/",
  classStudents: mainUrl + "/class_students/",
  attendanceUrl: mainUrl + "/attendance/",
  teacherScheduleUrl: mainUrl + "/teacher_schedule/",
  countsUrl: mainUrl + "/counts/",
  timeUrl: mainUrl + "/time/",
  changePasswordUrl: mainUrl + "/change_password/",
  examUrl: mainUrl + "/exam/",
  examResultsUrl: mainUrl + "/exam_results/",
  finalPoint: mainUrl + "/final_point/",
  teacherLessonUrl: mainUrl + "/teacher_lesson/",
  teacherCourseUrl: mainUrl + "/teacher_course/",
  examPoint: mainUrl + "/exam_point/",
  additionalPoint: mainUrl + "/additional_point/",
  getJournal: mainUrl + "/journal/",

  // Food urls
  getFoodListUrl: foodUrl + "/list/",
  getFoodCalendarDataUrl: foodUrl + "/huwaari/",
  getCourseBagts: foodUrl + "/bagts/",
  getBagtsOptions: foodUrl + "/options/bagts/",
  getCourses: foodUrl + "/courses/",
  // Sale food urls
  saleFoods: foodUrl + "/sale/",

  // Kindergarten urls
  kindergartenScheduleUrl: kindergartenUrl + "/schedule/",
  kindergartenScheduleDetailUrl: kindergartenUrl + "/schedule_detail/",
  // Library urls
  libraryLoginUrl: libraryUrl + "/auth/",
};
export default ApiList;
